// extracted by css-extract-rspack-plugin
export default {"EmptyStateFooter":"DiCbN"};